module.exports = __webpack_public_path__ + "img/3.04aff0b2.jpg";